import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { callPutApi } from '../api/ApiCaller';
import { PLAYER_CHANGE_PASSWORD_PUT } from '../api/ApiConst';
import { STATUS } from '../utils/Constants';

const Password_Security = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [twoFactorPassword, setTwoFactorPassword] = useState('');
    const [showTwoFactor, setShowTwoFactor] = useState(false);



    const handleSavePassword = () => {
        if (newPassword !== confirmNewPassword) {
            toast.error('New password and confirm new password do not match');
            return;
        }
        if (newPassword.length < 8) {
            toast.error('New password must be at least 8 characters long');
            return;
        }
        const payload = {
            newPassword: newPassword,
            confirmPassword: confirmNewPassword,
        };
        setIsLoading(true);
        callPutApi(PLAYER_CHANGE_PASSWORD_PUT, payload, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                toast.success(response.message, { id: "Toast" });
                setIsLoading(false);
                setNewPassword('');
                setConfirmNewPassword('');
            } else {
                setNewPassword('');
                setConfirmNewPassword('');
                setIsLoading(false);
                toast.error(response.message);
            }
        })
    }



    return (
        <div className='main-div-content'>
            <div div className='d-flex gap-3'>
                {/* Change Password Section */}
                <div className="ps-section">
                    <h3 className="ps-title">Change password</h3>
                    {/* <div className="ps-desc">
                        Enter your current password and set your new password.
                    </div>
                    <div className="ps-field">
                        <label>Current Password *</label>
                        <div className="ps-input-wrapper">
                            <input
                                type={showCurrent ? 'text' : 'password'}
                                value={currentPassword}
                                onChange={e => setCurrentPassword(e.target.value)}
                                className="ps-input"
                            />
                            <span
                                onClick={() => setShowCurrent(v => !v)}
                                className="ps-eye"
                                title={showCurrent ? 'Hide' : 'Show'}
                            >
                                {showCurrent ? '🙈' : '👁️'}
                            </span>
                        </div>
                    </div> */}
                    <div className="ps-field">
                        <label>New Password *</label>
                        <div className="ps-input-wrapper">
                            <input
                                type={showNew ? 'text' : 'password'}
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                className="ps-input"
                            />
                            <span
                                onClick={() => setShowNew(v => !v)}
                                className="ps-eye"
                                title={showNew ? 'Hide' : 'Show'}
                            >
                                {/* {showNew ? '🙈' : '👁️'} */}
                                <i className={showNew ? "fa fa-eye text-white" : "fa fa-eye-slash text-white"} aria-hidden="true"></i>
                            </span>
                            {/* <i className={showNewPassword ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i> */}
                        </div>
                    </div>
                    <div className="ps-field">
                        <label>Confirm New Password *</label>
                        <div className="ps-input-wrapper">
                            <input
                                type={showConfirm ? 'text' : 'password'}
                                value={confirmNewPassword}
                                onChange={e => setConfirmNewPassword(e.target.value)}
                                className="ps-input"
                            />
                            <span
                                onClick={() => setShowConfirm(v => !v)}
                                className="ps-eye"
                                title={showConfirm ? 'Hide' : 'Show'}
                            >
                                {/* {showConfirm ? '🙈' : '👁️'} */}
                                <i className={showConfirm ? "fa fa-eye text-white" : "fa fa-eye-slash text-white"} aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                    <button onClick={handleSavePassword} className="ps-save-btn" disabled={isLoading}>{isLoading ? 'Saving...' : 'Save'}</button>
                </div>

                {/* Two-Factor Authentication Section */}
                {/* <div className="ps-section">
                    <h3 className="ps-title">Two-Factor Authentication</h3>
                    <div className="ps-desc">
                        Two-factor authentication, also known as 2FA, adds an extra layer of security to your account. If enabled, the login process requires an authenticity check through a code sent to the email associated with your account.
                    </div>
                    <div className="ps-2fa-box">
                        <label>Confirm your password *</label>
                        <div className="ps-input-wrapper">
                            <input
                                type={showTwoFactor ? 'text' : 'password'}
                                value={twoFactorPassword}
                                onChange={e => setTwoFactorPassword(e.target.value)}
                                className="ps-input"
                            />
                            <span
                                onClick={() => setShowTwoFactor(v => !v)}
                                className="ps-eye"
                                title={showTwoFactor ? 'Hide' : 'Show'}
                            >
                                {showTwoFactor ? '🙈' : '👁️'}
                            </span>
                        </div>
                    </div>
                    <button className="ps-proceed-btn" disabled>Proceed</button>
                </div> */}
            </div>
        </div>
    );
};

export default Password_Security;